import { ReactNode } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ModalCloseIcon from "../../images/modal-close.svg";
// import "../../scss/Shared/sharedComponents.scss";

interface IModalProps {
  showModal: boolean;
  modalToggle: () => void;
  getHeaderDetails?: () => ReactNode;
  className?: string;
  children: ReactNode;
  overlay?: boolean;
  overlayChildren?: ReactNode;
  HeaderName?:string

}

const ModalComponent = ({
  showModal,
  modalToggle,
  getHeaderDetails,
  className,
  children,
  HeaderName
}: IModalProps) => {
  const closeBtn = (
    <button className="close" onClick={modalToggle} type="button">
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );

  return (
    <Modal isOpen={showModal} toggle={modalToggle} className={className}>
      <ModalHeader toggle={modalToggle} close={closeBtn}>
        {getHeaderDetails && getHeaderDetails()}
        <div className={`${className}-headerName`}>{HeaderName && HeaderName}</div>
      </ModalHeader>

      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};

export default ModalComponent;
